<div class="title-description">
  <h1>{{ title }}</h1>
  <span>{{ description }}</span>
</div>
